import script from "./modalokno.vue?vue&type=script&setup=true&lang=js"
export * from "./modalokno.vue?vue&type=script&setup=true&lang=js"

import "./modalokno.vue?vue&type=style&index=0&id=4f16dfe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f16dfe9"]])

export default __exports__